import { render } from "./VueCalendar.vue?vue&type=template&id=ecf1259c"
import script from "./VueCalendar.vue?vue&type=script&lang=js"
export * from "./VueCalendar.vue?vue&type=script&lang=js"

import "./VueCalendar.vue?vue&type=style&index=0&id=ecf1259c&lang=scss"

import exportComponent from "/home/runner/work/dotter/dotter/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__